import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, SocketEvents, Colors } from 'utils';
import {
  Table,
  Pagination,
  Input,
  Modal,
  ModalComments,
  RevisionTableRow,
  Countdown,
  Textarea,
} from 'components';
import { CleanIcon, Menu as MenuIcons, AddIcon } from 'assets/icons';
import { RevisionService, StorageService } from 'services';
import ModalPayment from 'components/modal-payment';
import ModalCreatePayment from './modal-create-payment';
import { TYPES } from '../home/home';
import ModalRating from '../home/modal-rating';
import { Alert } from 'assets/img';
import { WhiteImage } from 'assets/img';
import ModalUpload from './modal-upload';
import ModalLawyerRevision from './modal-lawyer-revision';
import * as Jetemit from 'jetemit';
import ModalSearchLawyer from './modal-search';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
  status: '',
};

// Formulario vacío para la búsqueda de abogado externo -- se resetea cada vez que la búsqueda finaliza
const INITIAL_SEARCH_FORM = {
  area_id: '',
  document_id: '',
  person_type_id: '',
};

class Revision extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: ['', '', '', '', '', ''],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    item: null,
    visible_modal: false,
    plan_user: undefined,
    visible_upload: false,
    membership_service: null,
    // ACCESS_DENIED  → sin membresía → paga fee (Caso 1)
    // ACCESS_LIMITED → membresía sin usos → abogado externo sin cobro (Caso 2)
    // ACCESS_GRANTED → membresía con usos → abogado interno sin cobro (Caso 3)
    membership_status: Constants.ACCES_STATUS.ACCESS_DENIED,
    visible_payment: false,
    visible_comments: false,
    visible_search: false,
    unsubscriber: () => {},

    search_form: INITIAL_SEARCH_FORM,
    search_revision: null as any,
    search_revision_status: null as number | null,
    search_lawyers: [] as any[],
    search_timer: 0,
    search_should_pay: false,
    visible_lawyer_detail: false,
    selected_lawyer: null as any,
    visible_lawyer_payment: false,
    unsubscriber_search_lawyer: () => {},
    unsubscriber_accept_lawyer: () => {},
    unsubscriber_client_response: () => {},
    visible_cancel: false,
    cancel_reason: '',
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: { title: 'Revisión Documental', onBack: null },
    });
    this.props.dispatch({ type: 'SET_SUBHEADER', payload: { title: '' } });

    this.setState({
      unsubscriber: Jetemit.on(SocketEvents.REVISION.ASSIGN_LAWYER, (data: any) => {
        /* @ts-ignore */
        if (+data?.user_id === +this.props.user?.id) {
          this.load(true);
          this.setState({ visible_search: false }, () => {
            if (data.status === Constants.REVISION_STATUS.PENDING) {
              return Globals.showSuccess('Un abogado ha aceptado su solicitud');
            }
            return Globals.showWarning(
              'Ningún abogado ha aceptado su solicitud, en breve será asignado',
            );
          });
        }
      }),

      unsubscriber_accept_lawyer: Jetemit.on(
        SocketEvents.SEARCH_REVISION.ACCEPT_LAWYER,
        (data: any) => {
          if (data.search_revision?.id == this.state.search_revision?.id) {
            this.setState({
              search_lawyers: data.lawyers || [],
              search_revision: data.search_revision,
            });
          }
        },
      ),

      unsubscriber_client_response: Jetemit.on(
        SocketEvents.SEARCH_REVISION.CLIENT_RESPONSE,
        (data: any) => {
          if (data.search_revision?.id != this.state.search_revision?.id) return;

          if (data.status == Constants.SEARCH_REVISION_STATUS.WAITING_FOR_USER_RESPONSE) {
            this.setState({
              search_timer: data.clientTimer,
              search_revision_status: data?.status,
              search_revision: data?.search_revision,
            });
          }

          if (data.status == Constants.SEARCH_REVISION_STATUS.FINISHED) {
            this.setState(
              {
                search_timer: 0,
                search_revision: null,
                search_form: INITIAL_SEARCH_FORM,
                search_revision_status: null,
                search_lawyers: [],
              },
              () => {
                // Si el cliente no está en medio de confirmar una elección
                // (modal de detalle/pago abierto), se le avisa.
                if (!this.state.visible_lawyer_detail && !this.state.visible_lawyer_payment) {
                  Globals.showWarning(data.message);
                }
              },
            );
          }
        },
      ),
    });

    this.load();

    this.loadSearch();
  }

  componentWillUnmount() {
    this.state.unsubscriber();
    this.state.unsubscriber_accept_lawyer();
    this.state.unsubscriber_client_response();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await RevisionService.get({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      user_id: this.props.user?.id,
    });
    this.setState({
      data: res.revisions.rows,
      last_page: res.revisions.count,
      plan_user: res.plan_user,
      membership_service: res.membership_service,
      membership_status: res.membership_status,
    });
  };

  loadSearch = async () => {
    try {
      const res: any = await RevisionService.getSearchRevision({
        user_id: this.props.user?.id,
        status: Constants.SEARCH_REVISION_STATUS.IN_SEARCH,
        withoutLoading: true,
        lawyers: true,
      });

      if (!res.search_revision) return;

      this.setState({
        search_revision: res.search_revision,
        search_timer: res.timer,
        search_lawyers: res.lawyers || [],
        search_form: {
          area_id: res.search_revision?.area_id?.toString() || '',
          document_id: res.search_revision?.document_id?.toString() || '',
          person_type_id: res.search_revision?.person_type_id?.toString() || '',
        },
      });
    } catch (error) {
      // Sin búsqueda activa o error de red -- se ignora, el cliente puede
      // iniciar una nueva búsqueda normalmente.
    }
  };

  reset = () => {
    this.setState({ form: INITIAL_STATE, page: 1 }, () => this.load(true));
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: { ...this.state.form, [e.target.name]: e.target.value },
      },
      callback,
    );
  };

  // Unificacion modal-create/modal-create-payment: ya no se elige modal segun
  // membership_status -- siempre se abre ModalCreatePayment, que internamente
  // decide si corresponde cobrar (ver selectType/submitNoPayment en ese archivo).
  add = () => {
    this.setState({ visible_payment: true });
  };

  onClose = (visible_search: boolean = false) => {
    this.setState({
      visible_payment: false,
      visible_search,
    });
  };

  onCreateModalClose = (reload: boolean = false, externalForm?: any) => {
    this.setState(
      {
        visible_payment: false,
      },
      () => {
        if (reload) this.load(true);
        if (externalForm) this.sendLawyerNotification(externalForm);
      },
    );
  };

  sendLawyerNotification = async (form: any) => {
    if (this.state.search_revision) return;

    try {
      const res: any = await RevisionService.sendLawyerNotification({
        user_id: this.props.user?.id,
        area_id: form.area_id,
        document_id: form.document_id,
      });

      if ('noLawyers' in res && res.noLawyers) {
        Globals.showWarning('No hay abogados disponibles para esta búsqueda');
        return;
      }

      this.setState({
        search_form: form,
        search_revision: res.search_revision,
        search_timer: res.timer,
        search_revision_status: res.search_revision?.status,
        // DESACTIVADO temporalmente: fee de plataforma en revisión documental
        // con abogados externos (directorio). Antes: search_should_pay = true
        // si el cliente no tenía membresía (ACCESS_DENIED), lo que hacía que se
        // cobrara el fee al elegir abogado. Ahora cualquier cliente puede
        // adquirir el servicio sin pagar comisión a la plataforma.
        // search_should_pay: this.state.membership_status === Constants.ACCES_STATUS.ACCESS_DENIED,
        search_should_pay: false,
      });
    } catch (error) {
      console.log(error);
    }
  };

  onSearchExpire = () => {
    if (this.state.search_lawyers.length > 0) return;
    this.setState({
      search_timer: 0,
      search_revision: null,
      search_form: INITIAL_SEARCH_FORM,
      search_revision_status: null,
    });
    Globals.showWarning('El tiempo de respuesta ha expirado, por favor intente más tarde');
  };

  changeSearchRevisionStatus = () => {
    Globals.confirm('¿Desea cancelar la busqueda?', async () => {
      try {
        await RevisionService.changeSearchRevisionStatus({
          search_revision_id: this.state.search_revision?.id,
          status: Constants.SEARCH_REVISION_STATUS.FINISHED,
        });
        this.setState({
          search_timer: 0,
          search_revision: null,
          search_form: INITIAL_SEARCH_FORM,
          search_revision_status: null,
          search_lawyers: [],
        });
        Globals.showSuccess('La busqueda ha sido cancelada');
      } catch (error) {}
    });
  };

  openLawyerDetail = (lawyerItem: any) => {
    const document_price = lawyerItem?.paper_documents?.find(
      (i: any) => i.document_id == this.state.search_form.document_id,
    );
    // DESACTIVADO temporalmente: fee de plataforma en revisión documental con
    // abogados externos (directorio). Antes: should_pay dependía de
    // search_should_pay (membresía) y de platform_fee_exempt del abogado
    // (excepción elegida a mano por el negocio). Ahora nunca se cobra fee.
    // const should_pay = this.state.search_should_pay && !lawyerItem?.platform_fee_exempt;
    const should_pay = false;
    this.setState({
      visible_lawyer_detail: true,
      selected_lawyer: {
        id: lawyerItem?.id,
        area: { name: this.state.search_revision?.area?.name },
        document: { name: this.state.search_revision?.document?.name },
        price: document_price?.fee,
        lawyer_reference_price: document_price?.lawyer_document_price,
        should_pay,
        platform_fee_exempt: lawyerItem?.platform_fee_exempt,
      },
    });
  };

  onCloseLawyerDetail = () => {
    this.setState({ visible_lawyer_detail: false, selected_lawyer: null });
  };

  // DEV-LT-35: acción del botón "Adquirir"/"Pagar fee y adquirir" dentro del
  // modal de detalle -- misma bifurcación que payService() en lawyer-info.tsx
  // (móvil):
  //   - should_pay = false (ACCESS_LIMITED) -> createNoPayment, sin cobro.
  //   - should_pay = true  (ACCESS_DENIED)  -> abre ModalPayment para cobrar
  //     el fee antes de crear la revisión.
  confirmLawyer = () => {
    const lawyer: any = this.state.selected_lawyer;
    if (!lawyer?.should_pay) {
      this.confirmLawyerNoPayment();
      return;
    }
    this.setState({ visible_lawyer_detail: false, visible_lawyer_payment: true });
  };

  confirmLawyerNoPayment = async () => {
    const lawyer: any = this.state.selected_lawyer;
    try {
      await RevisionService.createNoPayment({
        user_id: this.props.user?.id,
        lawyer_id: lawyer?.id,
        area_id: this.state.search_form.area_id,
        document_id: this.state.search_form.document_id,
        person_type_id: this.state.search_form.person_type_id,
        search_revision_id: this.state.search_revision?.id,
      });
      Globals.showSuccess('Se ha asignado el abogado correctamente');
      this.setState(
        {
          visible_lawyer_detail: false,
          selected_lawyer: null,
          search_revision: null,
          search_form: INITIAL_SEARCH_FORM,
          search_revision_status: null,
          search_lawyers: [],
        },
        () => this.load(true),
      );
    } catch (error: any) {
      // Antes esto se tragaba en silencio (solo console.log): el usuario no veía
      // ningún mensaje y el modal se quedaba como si no hubiese pasado nada. Ahora
      // se muestra el motivo real (ej: guardarraíl del backend, error de red, etc.)
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        'No se pudo asignar el abogado';
      Globals.showError(message);
    }
  };

  onCloseLawyerPayment = () => {
    this.setState({ visible_lawyer_payment: false, selected_lawyer: null });
  };

  // DESACTIVADO temporalmente: handler de éxito del pago del fee de plataforma
  // en revisión documental con abogados externos. Ya no se invoca porque
  // should_pay siempre es false (ver openLawyerDetail) y el modal de pago
  // (ModalPayment) ya no se abre, pero se deja comentado para reactivarlo si
  // se vuelve a habilitar el cobro del fee.
  // onLawyerPaymentSuccess = async (paymentData: any) => {
  //   const lawyer: any = this.state.selected_lawyer;
  //   try {
  //     const res: any = await RevisionService.saveWithPayment({
  //       hasFile: true,
  //       user_id: this.props.user?.id,
  //       lawyer_id: lawyer?.id,
  //       area_id: this.state.search_form.area_id,
  //       document_id: this.state.search_form.document_id,
  //       person_type_id: this.state.search_form.person_type_id,
  //       search_revision_id: this.state.search_revision?.id,
  //       ...paymentData,
  //     });

  //     const data = res?.data ?? res;
  //     if (!data?.ok) {
  //       Globals.showError(data?.message || 'Lo sentimos, no se pudo procesar el pago');
  //       return;
  //     }

  //     Globals.showSuccess('Su documento ha sido solicitado con éxito');
  //     const pdfUrl = data?.facturaPDF?.pdf;
  //     if (pdfUrl) window.open(pdfUrl, '_blank');

  //     this.setState(
  //       {
  //         visible_lawyer_payment: false,
  //         selected_lawyer: null,
  //         search_revision: null,
  //         search_form: INITIAL_SEARCH_FORM,
  //         search_revision_status: null,
  //         search_lawyers: [],
  //       },
  //       () => this.load(true),
  //     );
  //   } catch (error) {
  //     console.log(error);
  //     Globals.showError('Lo sentimos, no se pudo procesar el pago');
  //   }
  // };

  onCloseRating = (reload: boolean = false) => {
    this.setState({ visible_modal: false, type: null } as any, () => reload && this.load());
  };

  sendResponse = async (item: any, file: any) => {
    await RevisionService.saveResponse({
      file,
      revision_id: item.id,
      hasFile: true,
    });
    Globals.showSuccess('Se ha enviado el archivo correctamente');
    this.load(true);
  };

  rate = (item: any) => {
    this.setState({ item, visible_modal: true });
  };

  openCancelRevision = (item: any) => {
    this.setState({ item, cancel_reason: '', visible_cancel: true });
  };

  closeCancelRevision = () => {
    this.setState({ visible_cancel: false, item: null, cancel_reason: '' });
  };

  cancelRevision = async () => {
    if (!this.state.cancel_reason.trim()) {
      Globals.showError('Ingrese el motivo de la cancelación');
      return;
    }
    try {
      await RevisionService.cancel({
        revision_id: (this.state.item as any)?.id,
        user_id: this.props.user?.id,
        reason: this.state.cancel_reason.trim(),
      });
      Globals.showSuccess('Revisión cancelada correctamente');
      this.closeCancelRevision();
      this.load(true);
    } catch (error: any) {
      Globals.showError(error?.response?.data?.message || 'Error al cancelar la revisión');
    }
  };

  loadComments = async (withoutLoading: boolean = false) => {
    return await RevisionService.viewComments({
      revision_id: (this.state.item as any)?.id,
      withoutLoading,
    });
  };

  openCommentsModal = (item: any) => {
    this.setState({ item }, () => this.setState({ visible_comments: true }));
  };

  onCloseComments = (reload: boolean = false) => {
    this.setState({ visible_comments: false }, () => reload && this.load());
  };

  sendComments = async (item: any) => {
    await RevisionService.sendComments({
      revision_id: (this.state.item as any)?.id,
      user_id: this.props.user?.id,
      message: item.message,
      file: item.file,
      withoutLoading: true,
      hasFile: true,
    });
  };

  onCloseUpload = () => {
    this.setState({ visible_upload: false, item: null }, () => this.load(true));
  };

  openFile = async (key: string) => {
    const opened = await StorageService.openFile(key);
    if (!opened) Globals.showError('No se pudo obtener el archivo');
  };

  render() {
    const {
      visible_modal,
      visible_upload,
      visible_payment,
      visible_comments,
      visible_search,
      search_revision,
      search_revision_status,
      search_lawyers,
      search_timer,
      visible_lawyer_detail,
      visible_lawyer_payment,
      selected_lawyer,
      visible_cancel,
      cancel_reason,
    } = this.state;
    const plan_user: any = this.state.plan_user;

    return (
      <div id='client-revision'>
        {/* Unificacion modal-create/modal-create-payment: un solo modal para
            los 3 estados de membresia -- decide internamente si corresponde
            cobrar (ver selectType/submitNoPayment en ModalCreatePayment).
            onClose usa onCreateModalClose para poder recibir el formulario
            de "abogado externo" y disparar la búsqueda (ver DEV-LT-35 arriba). */}
        <Modal
          className='modal-create-revision'
          visible={visible_payment}
          title=''
          hideHeader={true}
          onClose={(reload: boolean, externalForm?: any) =>
            this.onCreateModalClose(reload, externalForm)
          }
        >
          {/* @ts-ignore */}
          <ModalCreatePayment
            item={this.state.item}
            plan_user={plan_user}
            membership_status={this.state.membership_status}
            onClose={(reload: boolean, externalForm?: any) =>
              this.onCreateModalClose(reload, externalForm)
            }
          />
        </Modal>

        <Modal className='modal-search-lawyer' visible={visible_search} title='' hideHeader={true}>
          <ModalSearchLawyer />
        </Modal>

        <Modal
          className='modal-lawyer'
          visible={visible_lawyer_detail}
          title=''
          onClose={() => this.onCloseLawyerDetail()}
        >
          {/* @ts-ignore */}
          <ModalLawyerRevision lawyer={selected_lawyer} action={() => this.confirmLawyer()} />
        </Modal>

        {/* Modal de pago del fee de plataforma en revisión documental con
            abogados externos — DESACTIVADO temporalmente: el fee ya no se
            cobra, should_pay siempre es false (ver openLawyerDetail) y este
            modal no puede abrirse.

        <Modal
          className='modal-lawyer'
          visible={visible_lawyer_payment}
          title=''
          onClose={() => this.onCloseLawyerPayment()}
        >
          <ModalPayment
            onClose={() => this.onCloseLawyerPayment()}
            price={selected_lawyer?.price}
            onSuccess={(data: any) => this.onLawyerPaymentSuccess(data)}
            title='Revisión Documental'
          />
        </Modal>
        */}

        <Modal
          className='modal-rating'
          visible={visible_modal}
          title='Calificar'
          onClose={() => this.onCloseRating()}
        >
          {/* @ts-ignore */}
          <ModalRating
            item={this.state.item}
            type={TYPES.REVISION}
            onClose={() => this.onCloseRating(true)}
          />
        </Modal>

        <Modal
          className='modal-upload-document'
          visible={visible_upload}
          title='Aceptaron tu solicitud'
          onClose={() => this.onCloseUpload()}
        >
          {/* @ts-ignore */}
          <ModalUpload item={this.state.item} onClose={() => this.onCloseUpload()} />
        </Modal>

        <Modal
          className='modal-comments'
          visible={visible_comments}
          title='Comentarios'
          onClose={() => this.onCloseComments()}
        >
          {/* @ts-ignore */}
          <ModalComments
            loadComments={(withoutLoading) => this.loadComments(withoutLoading)}
            sendComments={(item) => this.sendComments(item)}
            currentUser={(this.state?.item as any)?.lawyer}
            itemId={(this.state?.item as any)?.id}
            service={Constants.SERVICES.REVISION}
            writeComments={(this.state?.item as any)?.status == Constants.REVISION_STATUS.PENDING}
          />
        </Modal>

        <Modal
          className='modal-rating modal-cancel-call'
          visible={visible_cancel}
          title='Cancelar revisión'
          onClose={() => this.closeCancelRevision()}
        >
          <div className='container-cancel-call'>
            <p>Indique el motivo por el cual desea cancelar esta revisión documental.</p>
            <Textarea
              rows={4}
              placeholder='Motivo de la cancelación'
              value={cancel_reason}
              onChange={(e: any) => this.setState({ cancel_reason: e.target.value })}
            />
            <div className='btn-container'>
              <button className='btn btn-accept' onClick={() => this.cancelRevision()}>
                Confirmar cancelación
              </button>
            </div>
          </div>
        </Modal>

        <div className='row row-filter'>
          <div className='col-md-12'>
            <div className='row'>
              <div className='col-md-4'>
                <Input
                  value={this.state.form.search}
                  name='search'
                  label='Buscar'
                  placeholder='Buscar'
                  className='input-table'
                  onSubmit={() => this.load()}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => this.load(true), 1000);
                    this.change(e);
                  }}
                />
              </div>
              <div className='col-md-4'>
                {this.state.form != INITIAL_STATE && (
                  <button className='btn btn-clean' onClick={() => this.reset()}>
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
              {/* Botón siempre visible: el flujo de pago vs sin pago se decide en add() */}
              <div className='col-md-4 text-right'>
                <button className='container-add-table' onClick={() => this.add()}>
                  <img src={AddIcon} />
                  <p>Nuevo</p>
                </button>
              </div>
            </div>
          </div>
        </div>

        {search_revision && (
          <div className='container-search-revision'>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {search_revision_status === Constants.SEARCH_REVISION_STATUS.IN_SEARCH && (
                  <small>Buscando abogados...</small>
                )}
                {search_revision_status ===
                  Constants.SEARCH_REVISION_STATUS.WAITING_FOR_USER_RESPONSE &&
                  search_timer > 0 && (
                    <Countdown
                      startTime={new Date().toISOString()}
                      duration={search_timer}
                      unit='seconds'
                      onExpire={() => this.onSearchExpire()}
                      emptyMessage='El tiempo para elegir abogado ha finalizado'
                    />
                  )}
              </div>
              {search_revision_status === Constants.SEARCH_REVISION_STATUS.IN_SEARCH && (
                <button
                  className='btn btn-cancel-search'
                  onClick={() => this.changeSearchRevisionStatus()}
                >
                  Cancelar búsqueda
                </button>
              )}
            </div>
            <div className='search-lawyers-grid'>
              {search_lawyers.length === 0 && (
                <p className='no-lawyers-text'>Aún no hay abogados postulados</p>
              )}
              {search_lawyers.map((item: any, index: number) => {
                const document_price = item?.paper_documents?.find(
                  (i: any) => i.document_id == this.state.search_form.document_id,
                );
                return (
                  <div
                    key={index}
                    className='lawyer-card'
                    onClick={() => this.openLawyerDetail(item)}
                  >
                    <div className='lawyer-card__header'>
                      <div className='lawyer-card__info'>
                        <p className='lawyer-card__label'>Abogado</p>
                        <p className='lawyer-card__name'>{item?.full_name}</p>
                        {/* DESACTIVADO temporalmente junto con el fee de plataforma.
                        {item?.platform_fee_exempt && (
                          <span
                            style={{
                              backgroundColor: Colors.green,
                              color: '#fff',
                              borderRadius: '8px',
                              padding: '2px 6px',
                              fontSize: '10px',
                              fontWeight: 700,
                              display: 'inline-block',
                              marginTop: '4px',
                            }}
                          >
                            Sin comisión
                          </span>
                        )}
                        */}
                      </div>
                      <div className='lawyer-card__status'>
                        <small>Disponible</small>
                      </div>
                    </div>
                    <div className='lawyer-card__footer'>
                      <p className='lawyer-card__price-label'>Honorarios (a acordar)</p>
                      <p className='lawyer-card__price'>
                        {document_price?.lawyer_document_price != null
                          ? `${document_price.lawyer_document_price}$`
                          : 'A convenir'}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        <Table
          title=''
          data={this.state.data.length}
          header={this.state.header}
          headerContent={
            <div className='container-header-table'>
              <div className='container-icon'>
                <img src={MenuIcons.Menu6} />
              </div>
              <p>Registro de orden de revisión</p>
            </div>
          }
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <RevisionTableRow
                key={index}
                item={i}
                role='client'
                onOpenFile={(key) => this.openFile(key)}
                onSendResponse={(item, file) => this.sendResponse(item, file)}
                onOpenComments={(item) => this.openCommentsModal(item)}
                onOpenUpload={(item) => this.setState({ visible_upload: true, item })}
                onRate={(item) => this.rate(item)}
                onCancel={(item) => this.openCancelRevision(item)}
              />
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({ page });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return { user: state.user };
})(Revision);
